// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"recorder":"a048fc0892b28148","profiler":"e6566095b18258ad"}[chunkId] + ".js";
};